module.exports = "/_next/static/images/game-1-intro-tutorial-bg-7b5a72ef0e8acbe3306da9adf5083f27.jpg";